import {
    loginService,
    loginImageService,
    forgotPasswordService,
    resetPasswordService,
    updatePasswordService,
    validateSetPasswordTokenService,
} from '../../services/authServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

export async function loginUser(dispatch, loginPayload) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response = await loginService(loginPayload);
        // let data = await response.json();

        if (response.data) {
            sessionStorage.setItem('lastTimeStamp', new Date());
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', JSON.stringify(response.data.token));
            localStorage.setItem('customerportal_version', response.headers.customerportal_version);
            dispatch({ type: 'LOGIN_SUCCESS', payload: response.data.user });
            return response.data;
        }

        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ',
        });
        return response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ';
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response.data.message ? error.response.data.message : 'Invalid Email or password!',
        });
    }
}

export async function forgotPassword(payload) {
    const response = await forgotPasswordService(payload);
    return response.data;
}

export async function validateSetPasswordToken(token) {
    const response = await validateSetPasswordTokenService(token);
    return response.data;
}

export async function resetPassword(payload) {
    const response = await resetPasswordService(payload);
    return response.data;
}

export async function updatePassword(dispatch, data) {
    try {
        const response = await updatePasswordService(data);
        dispatch({ type: 'UPDATE_CONTACT_SUCCESS', payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'UPDATE_CONTACT_ERROR', error });
        throw error;
    }
}

export async function getLoginImage(dispatch) {
    try {
        let response = await loginImageService();
        if (response.data) {
            dispatch({ type: 'GET_LOGIN_IMAGE_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: error });
    }
}
